module.exports = __webpack_public_path__ + "img/overall.01292653.png";